export const style = {
    breadFontSize: {
        fontSize: '12px',
        textWrap: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    breadCrumbStyles: {
        overflow: 'hidden',
        '& .MuiBreadcrumbs-ol': {
            width: '100%',
            justifyContent: 'end',
            flexWrap: 'nowrap',
        },
        '& .MuiBreadcrumbs-ol > li:last-child': {
            width: '40%',
            '& .MuiTypography-root': {
                pt: '2px',
            },
        },
    },
};
export const CrumActive = {
    'smart-contracts-new': 'New Smart Contract',
    'consent-contracts-new': 'New Consent Contract',
    'edges-new': 'Create Edge Definitions',
    'dictionaries-new': 'Dictionary Name',
} as const;
export interface BreadCrumbsProps {
    status?: string;
    breadCrumType?: string;
    breadCrumData?: string;
    breadCrumLastItem?: string;
}
